import gql from 'graphql-tag';
import { mutation } from 'services/graphql';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const copySurfaceNodesMutation = gql`
  mutation copySurfaceNodes($input: [CopySurfaceNodesInput!]!) {
    copySurfaceNodes(input: $input) {
      ...surfaceNodeUnionDetails
    }
  }
  ${surfaceUnionFragment}
`;

export default mutation(copySurfaceNodesMutation);
